"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadOSS = uploadOSS;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es6.regexp.split");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ossSignature = require("@/api/ossSignature");
function random_string(len) {
  len = len || 32;
  var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
  var maxPos = chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}
function uploadOSS(_x) {
  return _uploadOSS.apply(this, arguments);
}
function _uploadOSS() {
  _uploadOSS = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(file) {
    var type,
      fileName,
      res,
      ossData,
      _args = arguments;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          type = _args.length > 1 && _args[1] !== undefined ? _args[1] : "activity";
          fileName = _args.length > 2 ? _args[2] : undefined;
          _context.n = 1;
          return (0, _ossSignature.getOssSignatureApi)({
            type: type
          });
        case 1:
          res = _context.v;
          ossData = res.data;
          return _context.a(2, new Promise(function (resolve, reject) {
            var timestamp = type === "builds" || type === "hmBuilds" ? fileName : random_string(8) + "." + file.name.split(".")[1];
            var formData = new FormData();
            formData.append("key", ossData.dir + timestamp); // 存储在oss的文件路径
            formData.append("OSSAccessKeyId", ossData.accessId); // 访问id
            formData.append("policy", ossData.policy); // policy
            formData.append("Signature", ossData.signature); // 签名
            formData.append("file", file);
            formData.append("success_action_status", 200); // 成功后返回的操作码
            var fileUrl = ossData.host + "/" + ossData.dir + timestamp;
            fetch(ossData.host, {
              method: "POST",
              mode: "no-cors",
              headers: {},
              body: formData
            }).then(function (response) {
              resolve(fileUrl);
            }).catch(function (e) {
              console.log(e);
            });
          }));
      }
    }, _callee);
  }));
  return _uploadOSS.apply(this, arguments);
}